/**
 * 文档管理 相关菜单配置
 *
 */

import { lazyLoad } from "@/utils/lazyLoad";
const trainingManageRoute = [
  {
    component: lazyLoad,
    path: "/training-manage",
    name: "trainingManage",
    meta: {
      title: "培训管理",
      icon: "icon-training",
      code: "training-manage",
    },
    children: [
      {
        path: "/training/list",
        name: "trainingList",
        component: () => import("../pages/trainingManage/list/index.vue"),
        meta: {
          title: "培训列表",
          keepAlive: true,
        },
      },
      {
        path: "/training/list/create",
        name: "trainingCreate",
        component: () => import("../pages/trainingManage/list/create.vue"),
        hidden: true,
        meta: {
          title: "培训材料",
          relatedPermission: "培训列表",
        },
      },
      {
        path: "/training/record",
        name: "trainingRecord",
        component: () => import("../pages/trainingManage/record/index.vue"),
        meta: {
          title: "培训记录",
          keepAlive: true,
        },
      },
    ],
  },
];
export default trainingManageRoute;
